import GetProductRequestModelBase from '../_generated/modelBases/get-product-request-model-base';

export default class GetProductRequestModel extends GetProductRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
